var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.128906,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5477 26.5219L23.7889 16.8816C23.5232 16.7189 23.2189 16.6301 22.9074 16.6243C22.5959 16.6186 22.2886 16.696 22.017 16.8488C21.7481 16.9992 21.5241 17.2185 21.368 17.4841C21.2119 17.7498 21.1294 18.0522 21.1289 18.3604V37.6388C21.1309 38.101 21.3164 38.5435 21.6446 38.869C21.9727 39.1945 22.4167 39.3763 22.8789 39.3746C23.2015 39.3744 23.5179 39.2855 23.7933 39.1175L39.5477 29.4772C39.8009 29.3229 40.0102 29.106 40.1554 28.8474C40.3006 28.5888 40.3769 28.2972 40.3769 28.0007C40.3769 27.7041 40.3006 27.4125 40.1554 27.1539C40.0102 26.8953 39.8009 26.6785 39.5477 26.5241V26.5219ZM22.8789 37.618V18.3746L38.6103 27.9996L22.8789 37.618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5212e9ef3af9d399da4a29ccaaacccf1.svg";
export { ForwardRef as ReactComponent };